import React from 'react'
import {
  ActivityIndicator as RNActivityIndicator,
  ActivityIndicatorProps,
  ColorValue,
} from 'react-native'
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withRepeat,
  withTiming,
  Easing,
} from 'react-native-reanimated'
import { Images } from 'APP/Themes'
import styled, { useTheme } from 'styled-components/native'
import Config from 'APP/Config'

// Styled component
const SpinnerContainer = styled.View<{ size: number }>`
  justify-content: center;
  align-items: center;
`

// Helios Spinner component
const HeliosSpinner: React.FC<{
  size?: 'large' | 'small' | number
  color?: ColorValue
  testID?: string
}> = ({ size, color, testID }) => {
  const sizeNumber = size === 'small' ? 24 : 64
  const rotation = useSharedValue(0)
  const SpinnerSVG: any = Images.spinner

  // Animation style
  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: `${rotation.value}deg` }],
  }))

  React.useEffect(() => {
    rotation.value = withRepeat(
      withTiming(360, { duration: 1200, easing: Easing.linear }),
      -1,
      false
    )
  }, [rotation])

  return (
    <SpinnerContainer size={sizeNumber} testID={testID}>
      <Animated.View style={animatedStyle}>
        <SpinnerSVG width={sizeNumber} height={sizeNumber} fillLine={color} />
      </Animated.View>
    </SpinnerContainer>
  )
}

const ActivityIndicator: React.FC<ActivityIndicatorProps> = ({
  size = 'large',
  color,
  style,
  ...props
}) => {
  const theme = useTheme()
  const spinnerColour = color || theme.colors.primary
  const isHelios = Config?.BRAND_ID === 'sunlife' && Config?.BRAND_VERSION === 'v2'

  if (isHelios) {
    return <HeliosSpinner size={size} color={spinnerColour} {...props} />
  }

  return <RNActivityIndicator size={size} color={spinnerColour} style={style} {...props} />
}

export default ActivityIndicator
